<template>
  <section class="section">
    <div id="news" class="container">
      <h1 class="title">News</h1>
      <p class="subtitle">Discuss the latest happenings in world of girls</p>
    </div>
  </section>
</template>

<script></script>

<style></style>
